module.exports = __webpack_public_path__ + "static/media/before-arrow-circle-black.51d85b68.svg";